/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivClearanceRequestControllerConfirmParamsGen,
  MrfiktivClearanceRequestControllerGetParamsGen,
  MrfiktivClearanceRequestControllerRequestCostExtensionParamsGen,
  MrfiktivClearanceViewModelGen,
  MrfiktivCreateClearanceResponseDtoGen,
  MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ClearanceRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags clearance-request
   * @name ClearanceRequestControllerGet
   * @summary (SCT) Get a Clearance via Shared Content Token
   * @request GET:/partner/{partnerId}/clearance/{clearanceId}/request
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The found clearance
   */
  clearanceRequestControllerGet = (
    { partnerId, clearanceId, ...query }: MrfiktivClearanceRequestControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}/request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-request
   * @name ClearanceRequestControllerConfirm
   * @summary (SCT) Confirm a Clearance via Shared Content Token
   * @request PATCH:/partner/{partnerId}/clearance/{clearanceId}/request/confirm
   * @secure
   * @response `200` `MrfiktivClearanceViewModelGen` The updated clearance
   */
  clearanceRequestControllerConfirm = (
    { partnerId, clearanceId, ...query }: MrfiktivClearanceRequestControllerConfirmParamsGen,
    data: MrfiktivCreateClearanceResponseDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}/request/confirm`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-request
   * @name ClearanceRequestControllerRequestCostExtension
   * @summary (sct) Request for cost extension on a clearance
   * @request PATCH:/partner/{partnerId}/clearance/{clearanceId}/request/cost-extension
   * @secure
   * @response `201` `MrfiktivClearanceViewModelGen` The updated clearance
   */
  clearanceRequestControllerRequestCostExtension = (
    { partnerId, clearanceId, ...query }: MrfiktivClearanceRequestControllerRequestCostExtensionParamsGen,
    data: MrfiktivUpdateRepairEstimateResponseAcceptDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceViewModelGen, any>({
      path: `/partner/${partnerId}/clearance/${clearanceId}/request/cost-extension`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
}
